import { HorizontalStackedBarChart } from 'Components/BaseCharts/HorizontalStackedBarChart';
import { CSSColors, Colors } from 'Components/Colors';
import { PageVariant } from 'Components/Table/Table';
import { Text } from 'Components/Text/Text';
import { iso8601ToUsDateShort } from 'Helpers/DateTimeUtils/DateTimeUtils';

import styles from './HeaderDashlets.module.css';
import { QuestionsStatistics } from '../../Hooks/useQuestionsStatistics';

export interface QuestionsDashletProps {
    pageVariant: PageVariant;
    /** Calculated by `useQuestionsStatistics`. */
    statistics: QuestionsStatistics;
    dueDate?: string;
}

/**
 * Renders a `HorizontalStackedBarChart` showing progress on the questions for a due diligence assessment.
 * Used in tables of all assessments as well as the header for a specific assessment.
 */
export const QuestionsDashlet = (props: QuestionsDashletProps) => {
    const textColor: Colors = props.pageVariant === 'standard' ? 'blue' : 'white';

    return (
        <>
            <HorizontalStackedBarChart
                name="Questions"
                bars={[
                    {
                        name: 'Answered Unacceptably',
                        value: props.statistics.unacceptable,
                        color: CSSColors.RED,
                    },
                    {
                        name: 'Answered',
                        value: props.statistics.answered - props.statistics.unacceptable,
                        color: CSSColors.BLUE,
                    },
                    {
                        name: 'Unanswered',
                        value: props.statistics.unanswered,
                        color: CSSColors.DARK_GRAY,
                    },
                ]}
                onChartClick={() => void 0}
                chartDimensions={{ width: '100%', height: 50 }}
            />
            <div className={styles.horizontalBarChartTextDecoration}>
                <Text color={textColor} noStyles>
                    {props.statistics.unacceptable} unacceptable answer{props.statistics.unacceptable === 1 ? '' : 's'}
                </Text>
                <div className={styles.rightAlignedColumn}>
                    <Text color={textColor} noStyles>
                        {props.statistics.answered}/{props.statistics.total} answered
                    </Text>
                    {props.dueDate && (
                        <Text color={textColor} noStyles>
                            Due {iso8601ToUsDateShort(props.dueDate)}
                        </Text>
                    )}
                </div>
            </div>
        </>
    );
};
